/* global appData */

import indexPage from './indexPage';

function setTitle(titleId) {
	indexPage.$headerTitle.html(appData.titleStrings[titleId]);
	indexPage.$headerSubTitle.html(appData.subTitleStrings[titleId]);
}

function changeColorAndIcon(color, icon) {
	removeAll();
	indexPage.$headerIcon.addClass(color);
	indexPage.$headerIcon.addClass(icon);
}

function removeAll() {
	indexPage.$headerIcon.removeClass('person');
	indexPage.$headerIcon.removeClass('red');
	indexPage.$headerIcon.removeClass('blue');
}

function shakeIcon() {
	indexPage.$headerIcon.addClass('shake');
	setTimeout(() => {
		indexPage.$headerIcon.removeClass('shake');
	}, 1000);
}

export { setTitle, changeColorAndIcon, shakeIcon };
